<template>
  <v-inventory-receive large @set-data="setData">
    <template #actions="{ data }">
      <v-btn text v-on:click="back">cancel</v-btn>
      <v-btn
        text
        color="primary"
        v-on:click="save(data)"
        :loading="receive_loading"
        :disabled="saveDisabled"
        >receive</v-btn
      >
    </template>
  </v-inventory-receive>
</template>
<script>
export default {
  name: "InventoryReceive",
  data: () => ({
    receiveData: null,
    receive_loading: false,
  }),
  computed: {
    form() {
      const fObj = {};
      return fObj;
    },
    disable() {
      let disable = false;
      let res_disable = 0;
      if (this.receiveData && typeof this.receiveData.items == typeof []) {
        for (const index in this.receiveData.items) {
          const item = this.receiveData.items[index];
          disable = disable || item.quality < item.received + item.to_receive;
          if (item.to_receive > 0) res_disable += 1
          else if(item.to_receive < 0) disable = true;
        }
      } else {
        disable = true;
      }
      disable = disable === false ? !res_disable : disable;
      return disable;
    },
    saveDisabled() {
      let formHasErrors = false || this.disable;
      Object.keys(this.form).forEach((f) => {
        if (!this.form[f]) formHasErrors = true;
      });
      return formHasErrors;
    },
  },
  methods: {
    setData(data) {
      this.receiveData = data;
    },
    async save(data) {
      this.receive_loading = true;
      const params = {
        items: data.items,
        additional_cost: data.additional_cost,
      };
      this.$communicator.then(
        this,
        await this.$communicator("receive_purchase", {
          arguments: [this.$route.query["id"]],
          params: params,
        })
      );
      this.back();
    },
    back() {
      if (this.$route.query["to"]) {
        this.$router.push({
          path: this.$route.query["to"] + "/view",
          query: {
            id: this.$route.query["id"],
          },
        });
      }
    },
  },
};
</script>
